import CryptoJS from 'crypto-js';

// 前端固定盐（需与后端一致）
const FRONTEND_SALT = import.meta.env.VITE_PASSWORD_SALT;
const SECRET_KEY = import.meta.env.VITE_SECRET_KEY;
const AES_KEY = import.meta.env.VITE_AES_SECRET_KEY;
const IV_KEY = import.meta.env.VITE_AES_IV_KEY;

// SHA-512哈希函数
export const hashPassword = (password: string) => {
  return CryptoJS.SHA224(password + FRONTEND_SALT).toString();
};

// 生成随机盐（用于注册）
export const generateSalt = (): string => {
  return CryptoJS.lib.WordArray.random(16).toString();
};

export const generateRequestSignature = () => {
  const timestamp = Date.now();
  const nonce = CryptoJS.lib.WordArray.random(8).toString();
  const signature = CryptoJS.HmacSHA256(`${timestamp}|${nonce}`, SECRET_KEY).toString(CryptoJS.enc.Base64);
  return `${timestamp}:${nonce}:${signature}`;
};

// 密钥和向量 (与后端保持一致)
const key = CryptoJS.enc.Utf8.parse(AES_KEY);
const iv = CryptoJS.enc.Utf8.parse(IV_KEY);

// AES加密方法
export const generateVerificationToken = (email: string) => {
  const timestamp = Date.now();
  const nonce = CryptoJS.lib.WordArray.random(8).toString();
  const encrypted = CryptoJS.AES.encrypt(`${timestamp}|${nonce}|${email}`, key, {
    // iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}